import { GetUsersForLicenseRoutine } from '../redux-routines';

export const initialState = {
  isFetching: false,
  data: [],
  apiKeys: [],
  error: null
};

export const licenseUsersReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GetUsersForLicenseRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case GetUsersForLicenseRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.users,
        apiKeys: action.payload.apiKeys,
        error: null
      };
    case GetUsersForLicenseRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    default:
      return state;
  }
};
